module.exports = __webpack_public_path__ + "static/media/USDT.43f688a0.svg";